<template lang="pug">
form.pt-5.pb-7(@submit.prevent='onSubmit', novalidate)
  .d-grid.gap-two.fs-18.pb-5
    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 1
        | ข้อมูลผู้ตอบแบบสอบถาม

      .d-flex.mb-4
        .flex-shrink-0.col-lg-1.text-dark.fw-500 เพศ
        div
          .form-check.form-check-inline(v-for='item in sex', :key='item')
            input.form-check-input(
              name='sex',
              type='radio',
              :value='item',
              v-model='form.sex',
              :id='`sex-${item}`',
              required
            )
            label.form-check-label.fw-300(:for='`sex-${item}`') {{ item }}

          .invalid-feedback(:class='{ show: !form.sex }') กรุณาเลือกเพศ

      .d-flex
        .flex-shrink-0.col-lg-1.text-dark.fw-500 สายงาน
        div
          .row.g-0
            .col-6(v-for='item in agencies', :key='item.id')
              .form-check.form-check-inline
                input.form-check-input(
                  name='agencie',
                  type='radio',
                  :value='item.name',
                  v-model='form.agencie',
                  :id='`agencie-${item.id}`',
                  required
                )
                label.form-check-label.fw-300(:for='`agencie-${item.id}`') {{ item.name }}

          .invalid-feedback(:class='{ show: !form.agencie }') กรุณาเลือกสายงาน

    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 2
        | ความพึงพอใจในด้าน “การใช้ข้อมูล” บนเว็บไซต์สายงานยุทธศาสตร์

      table.table.table-hover
        thead
          tr
            th(scope='col', width='50%') 
            th.text-center.fw-500.text-dark(
              scope='col',
              width='10%',
              v-for='level in levels',
              :key='level'
            ) {{ level }}
        tbody
          tr
            th.fw-300(scope='row') มีชื่อหน่วยงาน/แหล่งข้อมูล
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_information_1',
                type='radio',
                :value='level',
                v-model='form.use_information_1',
                required
              ) 
          tr
            th.fw-300(scope='row') ภาษาเข้าใจง่าย กระชับ อธิบายชี้แจงข้อมูลได้ชัดเจน
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_information_2',
                type='radio',
                :value='level',
                v-model='form.use_information_2',
                required
              ) 

          tr
            th.fw-300(scope='row') ข้อมูลเป็นปัจจุบันและถูกต้อง
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_information_3',
                type='radio',
                :value='level',
                v-model='form.use_information_3',
                required
              ) 

          tr
            th.fw-300(scope='row') ข้อมูลที่นำเสนอครบถ้วนตรงกับความต้องการ
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_information_4',
                type='radio',
                :value='level',
                v-model='form.use_information_4',
                required
              ) 

    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 3
        | ความพึงพอใจในด้าน “การใช้งาน” เว็บไซตสายงานยุทธศาสตร์

      table.table.table-hover
        thead
          tr
            th(scope='col', width='50%') 
            th.text-center.fw-500.text-dark(
              scope='col',
              width='10%',
              v-for='level in levels',
              :key='level'
            ) {{ level }}
        tbody
          tr
            th.fw-300(scope='row') ความรวดเร็วในการเข้าถึงหน้าเว็บเพจ
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_1',
                type='radio',
                :value='level',
                v-model='form.use_1',
                required
              ) 
          tr
            th.fw-300(scope='row') ใช้งานง่ายและสะดวกในการค้นหาข้อมูล
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_2',
                type='radio',
                :value='level',
                v-model='form.use_2',
                required
              ) 

          tr
            th.fw-300(scope='row') สามารถส่งข้อมูลติดต่อกลับได้
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='use_3',
                type='radio',
                :value='level',
                v-model='form.use_3',
                required
              ) 
    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 4
        | ความพึงพอใจในด้าน “รูปแบบ” ของเว็บไซตสายงานยุทธศาสตร์

      table.table.table-hover
        thead
          tr
            th(scope='col', width='50%') 
            th.text-center.fw-500.text-dark(
              scope='col',
              width='10%',
              v-for='level in levels',
              :key='level'
            ) {{ level }}
        tbody
          tr
            th.fw-300(scope='row') ตัวอักษรอ่านง่าย ชัดเจน และถูกต้อง
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='type_1',
                type='radio',
                :value='level',
                v-model='form.type_1',
                required
              ) 
          tr
            th.fw-300(scope='row') ภาพ สี และการออกแบบมีความเหมาะสม
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='type_2',
                type='radio',
                :value='level',
                v-model='form.type_2',
                required
              ) 

    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 5
        | ความพึงพอใจในด้าน “การใช้ประโยชน์” ของเว็บไซตสายงานยุทธศาสตร์

      table.table.table-hover
        thead
          tr
            th(scope='col', width='50%') 
            th.text-center.fw-500.text-dark(
              scope='col',
              width='10%',
              v-for='level in levels',
              :key='level'
            ) {{ level }}
        tbody
          tr
            th.fw-300(scope='row') การนำข้อมูลไปใช้ประโยชน์
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='utilization_1',
                type='radio',
                :value='level',
                v-model='form.utilization_1',
                required
              ) 
          tr
            th.fw-300(scope='row') อัพเดทข่าวสารของทุกสายงานได้รวดเร็ว
            td.text-center(scope='col', v-for='level in levels', :key='level')
              input.form-check-input(
                name='utilization_2',
                type='radio',
                :value='level',
                v-model='form.utilization_2',
                required
              ) 
    .survey-form-group.p-4
      h3.h4.text-dark.d-flex.mb-4
        span.text-primary.flex-shrink-0.me-3 ส่วนที่ 6
        | ข้อเสนอแนะ/ปัญหาของการใช้บริการ

      textarea.form-control(
        v-model='form.comment',
        rows='5',
        placeholder='กรอกข้อความ'
      )

  .text-end
    button.btn.btn-primary.btn-lg.rounded-0(
      type='submit',
      :disabled='isLoading'
    ) 
      span.spinner-border.spinner-border-sm.me-2(v-if='isLoading')
      template(v-if='isLoading') กำลังส่งแบบสำรวจ
      template(v-else) ส่งแบบสำรวจ

  #alertModal.modal.fade(
    tabindex='-1',
    aria-labelledby='alertModalLabel',
    aria-hidden='true'
  )
    .modal-dialog.modal-dialog-centered
      .modal-content
        .modal-body.text-center.py-5
          button.btn-close.position-absolute.end-0.top-0.mt-2.me-2(
            type='button',
            data-bs-dismiss='modal',
            aria-label='Close'
          )
          checkmark
          .py-4
            h5#alertModalLabel.modal-title.text-center ส่งข้อมูลสำเร็จ
            p ได้รับข้อมูลของท่านเรียบร้อยแล้ว
          button.btn.btn-primary.text-white.px-4(
            type='button',
            data-bs-dismiss='modal'
          ) ตกลง
</template>

<script>
import axios from 'axios'
import MoveTo from 'moveto'
import { Modal } from 'bootstrap'
import Checkmark from '../components/Checkmark.vue'
export default {
  components: { Checkmark },
  data() {
    return {
      form: {},
      isLoading: false,
      levels: ['มากที่สุด', 'มาก', 'ปานกลาง', 'น้อย', 'น้อยมาก'],
      sex: ['ชาย', 'หญิง'],
      agencies: [],
    }
  },

  watch: {
    $route() {
      this.fetchNews()
    },
  },

  created() {},

  mounted() {
    this.fetchAgencies()
  },

  methods: {
    fetchAgencies() {
      axios.get(`${PEA.api.url}wp/v2/news_agency`, {}).then(({ data }) => {
        this.agencies = data
      })
    },

    onSubmit() {
      const form = document.querySelector('form')

      if (!form.checkValidity()) {
        form.classList.add('was-validated')
        const moveTo = new MoveTo({ tolerance: 80 })
        const target = document.querySelector('input:invalid')
        moveTo.move(target)
      } else {
        this.isLoading = true
        axios
          .post(`${PEA.api.url}v1/feedback`, this.form)
          .then((response) => {
            this.isLoading = false
            const myModal = new Modal(document.getElementById('alertModal'))
            myModal.show()
            this.form = {}
          })
          .catch((error) => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.survey {
  &-form {
    &-group {
      background: #ffffff;
      box-shadow: 2px 4px 16px 1px rgba(0, 0, 0, 0.06);
    }
  }
}

th,
td {
  padding-top: 14px;
  padding-bottom: 14px;
}

.table > :not(:first-child) {
  border-top: none;
}

.was-validated {
  .show {
    display: block;
  }
}
</style>